"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = require("swiper");
var modules_1 = require("swiper/modules");
document.addEventListener('alpine:init', function () {
    Alpine.data('homes', function () {
        return {
            init: function () {
                var _this = this;
                var galleries = __spreadArray([], this.$root.querySelectorAll('[data-image-gallery]'), true);
                galleries.length && galleries.forEach(function (gallery) { return _this.setupGallery(gallery); });
            },
            setupGallery: function (selector) {
                new swiper_1.default(selector, {
                    modules: [modules_1.A11y, modules_1.Navigation, modules_1.Pagination],
                    loop: true,
                    speed: 500,
                    spaceBetween: 20,
                    slidesPerView: 1,
                    navigation: {
                        prevEl: selector.parentElement.querySelector('[data-image-gallery-prev]'),
                        nextEl: selector.parentElement.querySelector('[data-image-gallery-next]'),
                    },
                    pagination: {
                        el: selector.parentElement.querySelector('[data-image-gallery-pagination]'),
                        bulletClass: 'block size-2 rounded-full bg-white transition-colors duration-500',
                        bulletActiveClass: '!bg-peppermint',
                    },
                });
            },
        };
    });
});
